import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Config } from '../config';
import { Observable } from 'rxjs';
import {
  DriverLicenceEndorsement,
  DriverLicenceEndorsementsApiResponse,
  DriverLicenceEntitlement,
  DriverLicenceEntitlementApiResponse,
  DriverLicenceRestriction,
  DriverLicenceRestrictionsApiResponse,
  DriverLicenceSummary,
  DriverLicenceSummaryApiResponse,
  LicenceStatus,
} from '../model/licence.model';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class LicenceService {
  public constructor(private http: HttpClient) {}

  public getSummary(employeeNumber: string): Observable<DriverLicenceSummary[]> {
    const endpoint = `${Config.apiRoot.uri}licence/summary/${employeeNumber}`;

    return this.http
      .post<DriverLicenceSummaryApiResponse>(endpoint, null)
      .pipe(
        map((response) =>
          response.data.map(
            (summary) =>
              new DriverLicenceSummary(
                summary.firstName,
                summary.lastName,
                summary.referenceNumber,
                summary.receivedDate,
                summary.mandateExpires,
                summary.licenceExpiry,
                summary.issueNumber,
                summary.type
              )
          )
        )
      );
  }

  public getEndorsements(employeeNumber: string): Observable<DriverLicenceEndorsement[]> {
    const endpoint = `${Config.apiRoot.uri}licence/endorsements/${employeeNumber}`;

    return this.http.post<DriverLicenceEndorsementsApiResponse>(endpoint, null).pipe(
      map((response) =>
        response.data.map((endorsement) => ({
          convictionDate: endorsement.convictionDate,
          offenceDate: endorsement.offenceDate,
          disqualificationExpiryDate: endorsement.disqualEndDate,
          offenceCode: endorsement.offenceCode,
          points: endorsement.points,
          description: endorsement.description,
        }))
      )
    );
  }

  public getEntitlements(licenceStatus: LicenceStatus, employeeNumber: string): Observable<DriverLicenceEntitlement[]> {
    const endpoint = `${Config.apiRoot.uri}licence/category_summary/${licenceStatus}/${employeeNumber}`;

    return this.http.post<DriverLicenceEntitlementApiResponse>(endpoint, null).pipe(
      map((response) =>
        response.data.map((entitlement) => ({
          commenceDate: entitlement.commenceDate,
          expiryDate: entitlement.expiryDate,
          offenceCode: entitlement.code,
          identifier: entitlement.identifier,
          restrictionCodes: entitlement.restrictionCodes,
          description: entitlement.description,
        }))
      )
    );
  }

  public getRestrictions(): Observable<DriverLicenceRestriction[]> {
    const endpoint = `${Config.apiRoot.uri}licence/restriction_codes`;

    return this.http.post<DriverLicenceRestrictionsApiResponse>(endpoint, null).pipe(
      map((response) =>
        response.data.map((restriction) => ({
          code: restriction.code,
          description: restriction.description,
        }))
      )
    );
  }
}
